
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.23 52.48a6.23 6.23 0 11-12.46 0M4.75 52.71V45s5.72-3.92 7-16.77S19.6 8.44 30.06 8.44h-.12c10.46 0 17 6.92 18.31 19.78s7 16.77 7 16.77v7.72zM4.74 45.01h50.52M42 5c6.57 3.43 11 10.12 12.9 19.78M18 5C11.42 8.41 7 15.1 5.09 24.76","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M26.5 9V4.83c0-3.12 1.57-3.54 3.5-3.54s3.5.42 3.5 3.54V9","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    